import { t } from 'i18next';

function mapGeneric(label) {
  switch (label) {
    case 'address':
    case 'addressLine1':
      return 'AddressLine1';
    case 'addressAdditional':
      return 'AddressLine2';
    case 'billTo':
      return 'BillTo';
    case 'city':
      return 'City';
    case 'commodityCode':
      return 'Commodity';
    case 'companyName':
      return 'CompanyName';
    case 'contactName':
      return 'ContactName';
    case 'country':
      return 'Country';
    case 'declaredValue':
      return 'SctnQuoteDeclaredValue';
    case 'description':
      return 'Description';
    case 'email':
      return 'Email';
    case 'postalZipCode':
      return 'PostalZipCode';
    case 'province':
      return 'ProvinceState';
    case 'phoneNumber':
      return 'PhoneNumber';
    case 'unNumber':
      return 'UNNumber';
    case 'length':
      return 'ItemLength';
    case 'width':
      return 'ItemWidth';
    case 'height':
      return 'ItemHeight';
    case 'Invalid UN Code':
      return 'UN Code';
    default:
      return label;
  }
}

const apiDBVariableMapping = (label) => {
  let mappedValue = '';

  if (label.includes('.')) {
    const parts = label.split('.');
    const itemName = parts[0];
    const attribute = parts[1];
    mappedValue = `${itemName} ${t(mapGeneric(attribute))}`;
  } else if (label.startsWith('shipper') || label.startsWith('consignee')) {
    const type = label.startsWith('shipper') ? 'shipper' : 'consignee';
    const attribute = label.substring(type.length);
    const formattedAttribute = attribute.charAt(0).toLowerCase() + attribute.slice(1);
    mappedValue = `${t(type)} ${t(mapGeneric(formattedAttribute))}`;
  } else {
    mappedValue = t(mapGeneric(label));
  }

  if (!mappedValue || mappedValue.length === 0) return label;
  return mappedValue;
};

export default apiDBVariableMapping;
